module.exports = function() {
    if (!this.opts.checkbox) {
        return [];
    }

    const getters = this.$store.getters;

    return getters[`${this.name}_CHECKBOX/getSelected`];
};
